import { createSlice } from '@reduxjs/toolkit';
import { PlayerService } from '../../services/player.service';
import { RequestStatusesEnum } from '../../enums/request-statuses.enum';
import { getPlayerPersonalSegments } from './actions';

const initialState = {
    session: null,
    isLoggedIn: false,
    lastLoginTimeStamp: null,
    isRegistered: false,
    recentGames: [],
    balance: {
        Currency: '',
        CurrencySign: '',
    },
    loyalty: null,
    personalSegments: {
        status: RequestStatusesEnum.DEFAULT,
        data: null,
    },
};

//region Extra reducer methods
const setPersonalSegmentsData = (state, action) => {
    state.personalSegments.data = action.payload;
    state.personalSegments.status = action.payload
        ? RequestStatusesEnum.SUCCEDED
        : RequestStatusesEnum.FAILED;
};
//endregion

export const playerSlice = createSlice({
    name: 'player',
    initialState,
    reducers: {
        setPlayerSession(state, action) {
            state.session = action.payload;
        },
        setIsLoggedIn(state, action) {
            state.isLoggedIn = action.payload;
        },
        setLastLoginTimeStamp(state, action) {
            state.lastLoginTimeStamp = action.payload;
        },
        setIsRegistered(state, action) {
            state.isRegistered = action.payload;
        },
        setRecentGames(state, action) {
            state.recentGames = action.payload;
        },
        setBalance(state, action) {
            state.balance = action.payload;
        },
        setLoyalty(state, action) {
            state.loyalty = action.payload;
        },
        showLoginOrRegistration(state, action) {
            PlayerService.showLoginOrRegistration(action.payload ?? {});
        },
        setPersonalSegmentsWaitingStatus(state) {
            state.personalSegments.status = RequestStatusesEnum.WAITING;
        },
        resetPersonalSegments(state) {
            state.personalSegments.status = RequestStatusesEnum.DEFAULT;
            state.personalSegments.data = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getPlayerPersonalSegments.fulfilled, setPersonalSegmentsData);
    },
});
